import React from 'react';
import Sidebar from './gemini-chat/Sidebar/Sidebar.jsx';
import Main from './gemini-chat/Main/Main.jsx';
import ContextProvider from '../context/Context.jsx';

export const GeminiChatBot: React.FC = () => {
  return (
    <ContextProvider>
      <div style={{ 
        display: 'flex', 
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100vw', 
        height: '100vh',
        zIndex: 1000,
        backgroundColor: '#fff'
      }}>
        <Sidebar />
        <Main />
      </div>
    </ContextProvider>
  );
};
